import React, { useState } from "react";
import dayjs from 'dayjs';
import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Brightness1 } from "@mui/icons-material";
import SwitchCustom from "../switch";

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);  


const CardReport = () => {
  const [showReport, setShowReport] = useState(false)     
  const [start, setStart] = useState(dayjs('2022-09-20'));  
  const [end, setEnd] = useState(dayjs('2022-09-20'));  

  const handleChangeStart = (newValue) => {
    setStart(newValue);
  };
  
  const handleChangeEnd = (newValue) => {
    setEnd(newValue);
  };

  const data = {
    datasets: [
      {
        label: '# of Votes',
        data: [10, 16, 5, 6],
        backgroundColor: [
          '#F26422',
          '#004DA1',
          'rgba(2, 23, 47, 0.3)',
          '#DDE1E4'
        ],
        borderColor: [
          '#F26422',
          '#004DA1',
          'rgba(2, 23, 47, 0.3)',
          '#DDE1E4'
        ],
        cutout: '80%',
        borderWidth: 0,
      },
    ],
  };

  return (  
    <LocalizationProvider dateAdapter={AdapterDayjs}> 
      <div className="row">
        <div className="col-12 col-lg-7">
          <div className="font-size-16 font-weight-bold mt-2">
            <img alt="calendar" src="/images/calendar.svg" className="ms-2 mt-n1" height={18} />
            Хугацаа
          </div>
          <div className="my-4 d-flex align-items-center">
            <MobileDatePicker
              label="Эхлэл"
              inputFormat="MM/DD/YYYY"  
              value={start}
              onChange={handleChangeStart}
              renderInput={(params) => <TextField {...params} />}
            />
            <i className='bx bx-right-arrow-alt mx-1 mx-sm-3 font-size-24'></i>
            <MobileDatePicker
              label="Төгсгөл"
              inputFormat="MM/DD/YYYY"  
              value={end}
              onChange={handleChangeEnd}
              renderInput={(params) => <TextField {...params} />}
            />
          </div>
        </div>
        <div className="col-12 col-lg-5">
          <div className="d-flex align-items-center justify-content-start justify-content-lg-end w-100 ms-n2 mb-4">
            <SwitchCustom 
              value={showReport}
              handleChange={(e) => {setShowReport(!showReport)}}
            />
            <div className="font-size-14 font-weight-500">Тайланг дэлгэрэнгүй харах</div>
          </div>
        </div>
      </div>
      <div className="d-flex charts mx-0 mx-sm-n5 px-0 px-sm-5 mb-5">
        <div className="bordered report-chart mb-3 ms-0 ms-sm-3">
          <div className="dialog-sub-header bordered-header font-weight-500">Орлого болон Зарлага</div>
          <div className="d-flex">
            <div className="p-3 chart_container">
              <Doughnut data={data} />
              <div className="chart-label">
                  <div>₮1’024’000</div>
                  <div className="font-size-12 text-grey">Нийт</div>
              </div>
            </div>
            <div className="ps-3 pt-4 font-size-12">
              <div className="mb-1"><Brightness1 className="font-size-10 mb-1 text-primary"/> Орлого</div>
              <div className="mb-1"><Brightness1 className="font-size-10 mb-1 text-secondary"/> Нэмэлт орлого</div> 
              <div className="mb-1"><Brightness1 className="font-size-10 mb-1 text-grey"/> Зарлага</div> 
              <div className="mb-1"><Brightness1 className="font-size-10 mb-1 text-light-grey"/> Нэмэлт зарлага</div> 
            </div>
          </div>
        </div>
        <div className="bordered report-chart mb-3">
          <div className="dialog-sub-header bordered-header font-weight-500">Хугацаа</div>
          <div className="d-flex">
            <div className="p-3 chart_container">
              <Doughnut data={data} />
              <div className="chart-label">
                  <div>₮1’024’000</div>
                  <div className="font-size-12 text-grey">Нийт</div>
              </div>
            </div>
            <div className="ps-3 pt-4 font-size-12">
              <div className="mb-1"><Brightness1 className="font-size-10 mb-1 text-primary"/> Орлого</div>
              <div className="mb-1"><Brightness1 className="font-size-10 mb-1 text-secondary"/> Нэмэлт орлого</div> 
              <div className="mb-1"><Brightness1 className="font-size-10 mb-1 text-grey"/> Зарлага</div> 
              <div className="mb-1"><Brightness1 className="font-size-10 mb-1 text-light-grey"/> Нэмэлт зарлага</div> 
            </div>
          </div>
        </div>
      </div>
    </LocalizationProvider>
  );
};

export default CardReport